var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-289"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 376.37,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.31,
    y: 102.95,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,401.67l-17.46.3-8.83.12-8.87,0h-.45v-.46l0-11.19V390h.5l17.58.07,8.79.09,8.79.11h.24v.23Zm0,0-.24-11.19.24.24-8.79.11-8.79.09L43.16,391l.5-.5,0,11.19-.46-.45,8.71,0,8.75.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,283.7,176,284l-8.83.12-8.87,0h-.45v-.46l0-11.19V272h.5l17.58.07,8.79.08,8.79.11h.24v.24Zm0,0-.24-11.19.24.24-8.79.11-8.79.08-17.58.07.5-.5,0,11.19-.46-.46,8.71.05,8.75.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,297.81l-17.46.29-8.83.12-8.87,0h-.45v-.46l-.05-11.19v-.5h.5l17.58.07,8.79.08,8.79.11h.24v.24Zm0,0-.24-11.19.24.24-8.79.11-8.79.08-17.58.07.5-.5,0,11.19-.46-.46,8.71,0,8.75.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.2,
    y: 272.51,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.68,
    y: 390.48,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 44.93,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.84,70.23l-17.46.3-8.83.12-8.87,0h-.45v-.46L421.18,59v-.5h.5l17.58.07,8.79.09,8.79.11h.24V59Zm0,0L456.6,59l.24.24-8.79.11-8.79.08-17.58.07.5-.5,0,11.19-.46-.45,8.71,0,8.75.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,56.12l-17.46.3-8.83.12-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07,8.79.09,8.79.11h.24v.23Zm0,0-.24-11.19.24.24-8.79.11-8.79.08-17.58.07.5-.5,0,11.19-.46-.45,8.71,0,8.75.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,55.17V232.83H171.09V55.17Zm111.21,173.4h-107V59.43h107Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.88,
    y: 59.43,
    width: 106.95,
    height: 169.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.87,
    y: 141.87,
    width: 106.95,
    height: 4.26,
    transform: "translate(226.7 288) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 232.83,
    width: 131.16,
    height: 12.23,
    transform: "translate(226.7 477.89) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.87,59.43h107V168.86h-107Zm103,3.94H63.82V164.91h99.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.56,
    y: 59.43,
    width: 2.13,
    height: 105.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.01,
    y: 59.43,
    width: 2.13,
    height: 105.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.38 248.02 432.18 248.02 432.18 246.79 462.14 246.79 462.14 216.99 463.38 216.99 463.38 248.02",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.38 142.83 462.14 142.83 462.14 113.03 432.18 113.03 432.18 111.79 463.38 111.79 463.38 142.83",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.36 142.83 277.13 142.83 277.13 111.79 308.31 111.79 308.31 113.03 278.36 113.03 278.36 142.83",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.31 248.02 277.13 248.02 277.13 216.99 278.36 216.99 278.36 246.79 308.31 246.79 308.31 248.02",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.58 210.36 391.44 210.36 391.44 209.13 404.34 209.13 404.34 196.3 405.58 196.3 405.58 210.36",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.58 163.52 404.34 163.52 404.34 150.69 391.44 150.69 391.44 149.46 405.58 149.46 405.58 163.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.16 163.52 334.93 163.52 334.93 149.46 349.05 149.46 349.05 150.69 336.16 150.69 336.16 163.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.05 210.36 334.93 210.36 334.93 196.3 336.16 196.3 336.16 209.13 349.05 209.13 349.05 210.36",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,124.2H442.37V118H456Zm-13.13-.46H455.5V118.5H442.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.4,
    y: 119,
    width: 8.92,
    height: 4.23,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.39,
    y: 119.41,
    width: 1.23,
    height: 3.43,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.46,
    cy: 118.27,
    r: 1.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.29,
    y: 266.85,
    width: 146.12,
    height: 8.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.32,
    y: 275.77,
    width: 120.06,
    height: 24.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.38 280.64 53.32 283.02 53.32 275.77 173.38 275.77 173.38 280.64",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,295.74H71.41V280.43h83.88Zm-82.88-1h81.88V281.43H72.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.69,
    y: 286.02,
    width: 27.33,
    height: 4.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.35 441.94 48.37 441.94 59.94 300.39 70.08 300.39 52.35 441.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.08 300.39 68.89 309.86 59.17 309.86 59.94 300.39 70.08 300.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.35 441.94 178.33 441.94 166.76 300.39 156.62 300.39 174.35 441.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.62 300.39 157.81 309.86 167.53 309.86 166.76 300.39 156.62 300.39",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-289"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40.29 441.94 92.72 441.7 145.14 441.61 250 441.44 354.86 441.61 407.28 441.7 459.71 441.94 407.28 442.19 354.86 442.27 250 442.44 145.14 442.27 92.72 442.18 40.29 441.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.49,246.07s-27.5-3.85-21.07-37C376.42,209,407.14,215.92,397.49,246.07Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,246.07s-27.5-3.85-21.07-37C376.42,209,407.14,215.92,397.49,246.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.1,239.14c-.54-1.68-1.17-3.33-1.87-4.95,0-.21-.06-.42-.08-.63,0-.45-.07-.91-.11-1.37-.08-1-.14-2-.2-3-.11-2-.24-4-.27-5.95a.09.09,0,0,0-.17,0c0,2,0,4,0,6,0,1,.1,2,.16,3,0,.22,0,.44.05.66a59.49,59.49,0,0,0-5.51-9.42c-.95-1.32-1.94-2.59-3-3.81s-2.25-2.45-3.36-3.69c-.07-.08-.19,0-.12.12a49.12,49.12,0,0,1,5.3,7c.84,1.27,1.62,2.56,2.38,3.88l-.26-.1c-.33-.13-.65-.27-1-.39-.75-.29-1.5-.58-2.24-.85-1.48-.55-3-1.09-4.43-1.65-.09,0-.15.12-.06.16,1.46.58,2.91,1.2,4.35,1.82l2.13.91,1.08.45a3.18,3.18,0,0,0,.73.26c.55,1,1.1,2,1.61,3a73.46,73.46,0,0,1,3.36,7.92l.19.57a16,16,0,0,0-2.25-1.09l-2.84-1.29c-1.93-.89-3.85-1.79-5.7-2.83-.09,0-.17.09-.08.15,1.89,1,3.74,2.13,5.64,3.15.94.52,1.89,1,2.86,1.48a8.85,8.85,0,0,0,2.58,1,32.64,32.64,0,0,1,1.81,7.8c.3,3.75.27,7.53.36,11.3,0,.06.09.06.1,0,.27-3.41.42-6.85.44-10.28A30,30,0,0,0,396.1,239.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.86,219.62a33.68,33.68,0,0,0-.27,5.85,0,0,0,1,0,.08,0c.11-1.94.13-3.88.36-5.81C392,219.55,391.88,219.51,391.86,219.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,221.28a20.67,20.67,0,0,1-3.53-1.74c-.09-.06-.18.09-.08.15A13.5,13.5,0,0,0,384,221.4C384,221.42,384.07,221.31,384,221.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,298.76c0-3-.08-6.08-.11-9.11-.06-10.09-.14-20.18-.32-30.27q-.23-12-.56-24a.11.11,0,0,0-.07-.1q0-3.28,0-6.57c0-.05-.06-.08-.13-.08s-.13,0-.13.09c0,2.19,0,4.38,0,6.57,0,0-.06.05-.06.1-.41,14.25-.77,28.51-.85,42.77,0,2.9,0,5.8,0,8.7q-.15,13.94-.11,27.88l0,4.44c0,8.51.09,17,.09,25.52,0,.46.51.69,1,.71s1.27-.22,1.27-.75c0-9.38.07-18.76.07-28.14C398.39,310.58,398.41,304.67,398.36,298.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,289.53s-13.22-9.8-25.77-3.18-14.52,32.14-14.52,32.14,18.43,2.64,30-8.41C387.81,299.44,386.88,289.53,386.88,289.53Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,290.13a16,16,0,0,0-7.66-1,11.09,11.09,0,0,0-1.62-.15l-1.87-.14-3.85-.28c-2.61-.19-5.23-.35-7.83-.61-.1,0-.11.15,0,.16,2.58.33,5.14.7,7.73,1,1.32.13,2.65.27,4,.37l1,.09c-.39.09-.78.18-1.17.29a31.38,31.38,0,0,0-6,2.44c-1,.18-2.08.47-3.1.72-1.64.38-3.27.8-4.89,1.23-3.21.84-6.39,1.79-9.58,2.71a.08.08,0,0,0,.05.16c3.19-.78,6.39-1.49,9.58-2.25,1.55-.37,3.1-.73,4.65-1.12l1.21-.28a39,39,0,0,0-9.4,8.18,51.24,51.24,0,0,0-6.53,10.3c0,.09.09.18.14.09a50.21,50.21,0,0,1,7.91-10.38l-.18.53c-.24.78-.49,1.56-.73,2.34-.49,1.56-1,3.11-1.45,4.68,0,.1.13.13.16,0,.56-1.51,1.09-3,1.62-4.55.26-.74.52-1.49.79-2.23l.39-1.16.13-.36a47.89,47.89,0,0,1,4.69-4,35.64,35.64,0,0,1,7-4c-.05.23-.09.46-.13.68-.13.6-.27,1.2-.39,1.81-.26,1.25-.5,2.5-.75,3.76-.5,2.56-.81,5.15-1.29,7.71a.09.09,0,0,0,.17,0c.59-2.57,1.35-5.11,1.93-7.69.29-1.29.58-2.58.84-3.87.13-.6.25-1.21.37-1.81.07-.34.15-.68.19-1,.24-.09.47-.2.72-.29,3.46-1.29,7.3-2.22,11-1.51a10.81,10.81,0,0,1,8,6.38c.12.29.57.11.51-.19C396.05,293.72,393.39,291.35,390.49,290.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24,301l-1.11,5a37,37,0,0,0-.93,4.89c0,.06.09.06.11,0a37.44,37.44,0,0,0,1.12-4.93c.33-1.65.65-3.3,1-5A.09.09,0,0,0,370.24,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,305.29c-1.68.86-3.31,1.83-5.07,2.53a.08.08,0,1,0,.07.15,55.86,55.86,0,0,0,5-2.61A0,0,0,0,0,357.45,305.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,271.54s-16.17,1-23.69-9.63S360.34,236,360.34,236s17,2.06,23.72,9.72S389.86,271.54,389.86,271.54Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,287.48c-.56-1.73-1.25-3.43-1.9-5.13s-1.3-3.25-2-4.85a101.29,101.29,0,0,0-4.84-9.52c-1.14-2-2.36-3.87-3.62-5.75,0-.28-.08-.57-.13-.86-.07-.5-.14-1-.22-1.5-.16-1-.34-2-.51-3.06-.38-2.24-.84-4.45-1.19-6.69,0-.1-.18-.1-.17,0,.33,2.2.55,4.42.86,6.63.15,1.08.29,2.17.46,3.25l.18,1.17a119.14,119.14,0,0,0-8-10.37l-1.18-1.32c0-.12-.11-.24-.15-.37l-.36-.92-.7-1.93c-.45-1.27-.86-2.54-1.2-3.84a.08.08,0,0,0-.16,0c.33,1.33.67,2.66,1.06,4,.19.63.39,1.25.62,1.87,0,.11.07.21.11.32-2.06-2.26-4.22-4.43-6.4-6.57-.07-.08-.19,0-.11.12a116.82,116.82,0,0,1,11.45,14,8.42,8.42,0,0,0-1.2-.3c-1.24-.24-2.5-.42-3.75-.58-2.64-.34-5.26-.67-7.88-1.08-.11,0-.15.14,0,.16,2.5.49,5,1.06,7.47,1.63,1.17.27,2.35.5,3.53.73a22.54,22.54,0,0,1,2.84.81c.26.37.53.74.79,1.12,1.19,1.72,2.32,3.49,3.44,5.26l-1.65-.32c-1.25-.24-2.5-.47-3.76-.68-2.46-.4-4.93-.83-7.37-1.38-.1,0-.14.13,0,.16,2.48.58,4.92,1.26,7.38,1.91q1.77.47,3.57.87l1.8.39a4.15,4.15,0,0,0,.72.12q3.54,5.75,6.63,11.75c.9,1.75,1.77,3.53,2.61,5.32s1.61,3.71,2.4,5.57C397,288,397.57,287.89,397.44,287.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,250.34c-.31-1.54-.64-3.08-1-4.62,0-.1-.18-.05-.16.05.31,1.52.6,3,.88,4.55a46,46,0,0,0,.91,4.53,0,0,0,0,0,.05,0A31.18,31.18,0,0,0,380.9,250.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.47,249.89a24.78,24.78,0,0,0-2.32-1l-1.23-.48-.62-.25a3.19,3.19,0,0,1-.68-.3c-.13-.09-.2.12-.08.14a3,3,0,0,1,.69.29l.61.27,1.18.52a20.49,20.49,0,0,0,2.39,1C371.5,250.08,371.56,249.93,371.47,249.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,258.83s9.78-18.28,24.66-21.1,24,12.48,24,12.48-10.85,13.86-24.51,16.28S406.4,258.83,406.4,258.83Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,245.91a40.75,40.75,0,0,0-11.67.14l.66-.35,3.3-1.7c2.29-1.19,4.6-2.46,7-3.42a.08.08,0,1,0-.07-.15c-2.33,1.09-4.74,2-7.08,3.07-1.16.54-2.31,1.1-3.45,1.7-.73.39-1.55.75-2.27,1.22a41.22,41.22,0,0,0-9.46,3.14l1.86-2c1.39-1.52,2.76-3.12,4.28-4.5.08-.07,0-.19-.12-.12-1.56,1.42-3.2,2.73-4.71,4.2-.74.71-1.44,1.45-2.12,2.21-.34.38-.68.77-1,1.18a39.17,39.17,0,0,0-19.95,26.94c0,.1.13.16.16.05A45,45,0,0,1,407.32,259,42.89,42.89,0,0,1,441,246.21C441.21,246.22,441.22,245.94,441,245.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.06,250.21s-10.86,13.86-24.52,16.28c-10.42,1.85-19-3.59-22.47-6.26l-.75-1.24s7.05-5.94,20.37-9.36S455.06,250.21,455.06,250.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.39,239.4a36.18,36.18,0,0,0-3.3,2.18,20.45,20.45,0,0,0-2.87,2.63c-.08.08,0,.19.13.12,1-.86,2-1.72,3-2.53a31.46,31.46,0,0,1,3.13-2.26A.08.08,0,0,0,432.39,239.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.56,242.49c-.55.23-1.11.43-1.67.66l-1.65.69c-.12,0-.06.24.06.19l1.66-.67c.55-.23,1.09-.48,1.65-.71C440.71,242.61,440.66,242.45,440.56,242.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.45,281.82s2.61,18.13,16.24,24.47,30.25,0,30.25,0S444.4,267.07,404.45,281.82Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.55,294.5c-1.26-.15-2.51-.36-3.76-.59l-1.83-.34-.95-.2c-.37-.34-.73-.69-1.11-1a55.42,55.42,0,0,0-8.33-6,46.22,46.22,0,0,0-5-2.57h.26l4.48.2c3,.14,6,.2,9,.4.1,0,.1-.16,0-.17-3-.2-6-.53-9-.79l-4.36-.39-2.24-.19-.58-.07c-.78-.29-1.56-.56-2.35-.81a21.32,21.32,0,0,0-11.55-.63c-3.43.87-6.85,3.12-7.74,6.74,0,.12.17.21.22.08,1.28-3,4.63-4.54,7.66-5.17a18.26,18.26,0,0,1,6.17-.12,15.27,15.27,0,0,0,.69,2.74c.38,1.28.75,2.55,1.14,3.83.77,2.54,1.62,5.06,2.37,7.61a.08.08,0,0,0,.16,0c-.63-2.55-1.16-5.11-1.78-7.66-.3-1.25-.61-2.5-.92-3.75a22,22,0,0,0-.69-2.58,35,35,0,0,1,3.54.83,51.32,51.32,0,0,1,6.17,2.27c.2,1.29.49,2.57.79,3.84.37,1.6.79,3.19,1.29,4.75a.08.08,0,0,0,.16,0l-.06-.3h0c-.3-1.49-.63-3-.94-4.44-.25-1.2-.49-2.4-.75-3.59a53.85,53.85,0,0,1,5,2.52c0,.37.13.75.18,1.08.1.62.21,1.24.32,1.86.26,1.4.54,2.79.87,4.18a65.43,65.43,0,0,0,2.35,7.88.08.08,0,0,0,0,.1l.08.09c.06.07.15,0,.13-.08-.63-2.69-1.35-5.35-1.94-8.05-.29-1.34-.59-2.69-.86-4-.13-.68-.26-1.35-.38-2,0-.19-.07-.4-.1-.61a58.32,58.32,0,0,1,5.31,3.54,57.72,57.72,0,0,1,8.12,7.42c.1.11.29,0,.2-.16a49.18,49.18,0,0,0-3.25-4c-.68-.74-1.39-1.45-2.12-2.14l.23,0c.64.1,1.28.2,1.92.28,1.26.17,2.52.3,3.79.44C441.61,294.67,441.65,294.51,441.55,294.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,300.64h0c0-.16-.05-.31-.08-.47s-.14-.39-.17-.59h0c-.28-1.21-.52-2.43-.74-3.65,0-.09-.15-.06-.14,0a14.8,14.8,0,0,0,1,4.73c0,.05.11,0,.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.56,300.35c0-.05,0-.07-.08-.08-.38-1.6-.75-3.21-1.08-4.82-.18-.85-.35-1.7-.52-2.55-.08-.46-.17-.92-.25-1.38a4.25,4.25,0,0,0-.29-1.18.09.09,0,0,0-.16,0,8.11,8.11,0,0,0,.34,2.43c.17.88.34,1.77.54,2.65.39,1.78.84,3.57,1.35,5.33,0,.09.18.07.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,289.28c-2.49-.34-5-.71-7.47-1-.1,0-.15.15,0,.17,2.49.36,5,.67,7.47,1C440.37,289.45,440.41,289.29,440.3,289.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,239.31s-8.34-36.59,31-51.39C428.44,187.92,439.33,236.08,397.47,239.31Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,218.56l.42-.26c.75-.4,1.49-.82,2.23-1.24l4.56-2.55c3-1.68,6-3.42,9-5.06a.09.09,0,0,0-.09-.15c-3,1.65-6.1,3.19-9.15,4.8l-4.51,2.38-1.84,1c1.31-2.48,2.72-4.92,4.25-7.27,2.06-3.13,4.31-6.12,6.65-9a.13.13,0,0,0-.19-.19,62.5,62.5,0,0,0-9.09,11.15c0-.13,0-.26,0-.38.05-.91.07-1.82.08-2.73,0-1.79-.06-3.58,0-5.36a.09.09,0,0,0-.17,0c-.07,1.76-.28,3.51-.38,5.27,0,.88-.09,1.75-.12,2.63,0,.47-.06,1,0,1.53-.81,1.29-1.59,2.6-2.32,3.92a70.22,70.22,0,0,0-3.52,7.37c0-.91-.09-1.82-.14-2.73-.12-2-.37-4-.45-6a.09.09,0,0,0-.17,0c0,2-.05,4,0,6,0,1,.06,2,.13,3,0,.36,0,.74.07,1.12a66.78,66.78,0,0,0-3,10.05,105.4,105.4,0,0,0-1.46,11.05s0,0,0,0a59.1,59.1,0,0,1,2.08-9.85c.49-1.73,1-3.45,1.56-5.15,1.63-.77,3.2-1.74,4.78-2.61s3.29-1.8,4.93-2.7c3.28-1.8,6.55-3.63,9.94-5.22.1-.05,0-.19-.09-.14-3.43,1.55-6.88,3-10.24,4.72-1.68.84-3.33,1.74-5,2.66-1.37.77-2.77,1.54-4.07,2.42.38-1.14.77-2.27,1.21-3.39A96.14,96.14,0,0,1,406,218.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.64,210.2c0-.11-.18-.11-.17,0,.14,2.09.21,4.17.43,6.26a.1.1,0,0,0,.19,0C403,214.36,402.79,212.28,402.64,210.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,217.18c-2.47,1-4.95,1.93-7.4,3-.06,0,0,.14,0,.11,2.48-.93,4.93-1.94,7.4-2.91C421.63,217.3,421.59,217.14,421.49,217.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.22,200.31a64.31,64.31,0,0,0-7,3.75.11.11,0,0,0,.11.18c2.28-1.34,4.6-2.62,7-3.79C425.41,200.4,425.32,200.26,425.22,200.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.93,
    y: 318.43,
    width: 56.7,
    height: 59.76,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.03,
    y: 339.58,
    width: 2.9,
    height: 102.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.32,
    y: 339.58,
    width: 2.9,
    height: 102.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.22,
    y: 339.58,
    width: 2.9,
    height: 102.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.48,
    y: 374.36,
    width: 61.29,
    height: 8.27,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Butterfly--inject-289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.22,187.36c1.26.87-1.67,4.1-2.48,5.31s-3.49,6.15-4.14,5.73.93-4.44,2.62-7.34C378.57,188.74,380.43,186.82,381.22,187.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.51,182.85a3,3,0,0,1,.67,1.07,4.2,4.2,0,0,1-.4,3.69c.07-.42.16-.81.2-1.21a7.19,7.19,0,0,0-.1-2.39A7.1,7.1,0,0,0,380.51,182.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,181.64c-.27.05.14,1.11.47,1.3a3.06,3.06,0,0,0,.56.24S380,181.59,379.74,181.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.88,184.2a3.39,3.39,0,0,0-1.05.68,12.45,12.45,0,0,0-.89.89c-.28.3-.55.63-.83.95s-.54.65-.85,1a8.37,8.37,0,0,1,.6-1.15,7.82,7.82,0,0,1,.79-1,5.88,5.88,0,0,1,1-.87A2.24,2.24,0,0,1,384.88,184.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,183.64c.22.17-.6,1-1,1a2.86,2.86,0,0,1-.6,0S385.22,183.49,385.42,183.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,184.07h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.17,190.76c.35,2.71-8.26,6.7-9.89,8-.58.49-1.48,1.34-2.5,2.18h0l-.34.29c-1.5,1.19-3.18,2.25-4.43,2l-.16,0a1.93,1.93,0,0,1-.44-.2c-2.13-1.36-6.4-13,0-19.38,1.53-1.53,4.26-1.27,7.12-.23h0C366.55,185.29,372,189.57,372.17,190.76Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.17,190.76c.35,2.71-8.26,6.7-9.89,8-.58.49-1.48,1.34-2.5,2.18h0l-.34.29c-1.5,1.19-3.18,2.25-4.43,2l-.16,0a1.93,1.93,0,0,1-.44-.2c-2.13-1.36-6.4-13,0-19.38,1.53-1.53,4.26-1.27,7.12-.23h0C366.55,185.29,372,189.57,372.17,190.76Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,186.23c-2.22,4.12-1.44,11-.17,13.83.92,2.08,4.25,1.15,5,.92l-.34.29c-1.5,1.19-3.18,2.25-4.43,2l-.16,0a1.93,1.93,0,0,1-.44-.2c-2.13-1.36-6.4-13,0-19.38,1.53-1.53,4.26-1.27,7.12-.23h0C358.85,183.28,356.12,184.12,355,186.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.69,202.25a32.2,32.2,0,0,1,3.59-3.61,11.75,11.75,0,0,1,2.19-1.33c.76-.38,1.53-.74,2.3-1.1a27.09,27.09,0,0,0,4.49-2.29c.71-.45,1.41-.92,2.08-1.44a9.32,9.32,0,0,0,1.83-1.72,8.47,8.47,0,0,1-1.71,1.88c-.65.54-1.33,1.05-2,1.54-.35.24-.69.48-1.06.71s-.75.41-1.13.6c-.77.38-1.54.73-2.31,1.09s-1.54.69-2.29,1.06a13.57,13.57,0,0,0-2.17,1.24c-.67.51-1.3,1.07-1.93,1.64S356.3,201.66,355.69,202.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.67,199.39a17.37,17.37,0,0,1,2.34-1.52,10,10,0,0,1,2.6-1.07,18.75,18.75,0,0,1,2.77-.43l1.39-.1c.47,0,.93,0,1.4,0l-2.75.42c-.91.16-1.83.3-2.71.51a14.13,14.13,0,0,0-2.56,1c-.42.19-.84.4-1.25.61S354.08,199.18,353.67,199.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.21,195.78l2.5-.13c.84-.05,1.67-.1,2.5-.18s1.66-.17,2.47-.31c.21,0,.41-.07.61-.12a5.69,5.69,0,0,0,.59-.16l.28-.1.26-.13a4.48,4.48,0,0,1,.58-.29,20.33,20.33,0,0,1,2.44-.7c.81-.19,1.61-.42,2.4-.68a9.75,9.75,0,0,0,4.2-2.55,7.49,7.49,0,0,1-1.84,1.71,10.61,10.61,0,0,1-2.26,1.13,20.9,20.9,0,0,1-2.41.74,21.93,21.93,0,0,0-2.38.71,5.43,5.43,0,0,0-.54.27l-.3.15-.31.1a4.85,4.85,0,0,1-.63.16l-.62.12a21.5,21.5,0,0,1-2.52.25A49.44,49.44,0,0,1,353.21,195.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.32,192.81c1.58-.17,3.16-.26,4.75-.29a23.76,23.76,0,0,1,2.38.08c.4,0,.82.14,1.16.13a5.55,5.55,0,0,0,1.14-.14,45.9,45.9,0,0,0,4.55-1.27l2.27-.69c.39-.1.77-.21,1.16-.3a3.13,3.13,0,0,1,1.18-.12,1.47,1.47,0,0,0-.59.07c-.19,0-.38.1-.57.16-.37.11-.75.24-1.12.38l-2.23.79c-.75.27-1.5.52-2.26.75a22.44,22.44,0,0,1-2.31.62,6.16,6.16,0,0,1-1.22.13c-.45,0-.8-.13-1.19-.15-.78-.09-1.57-.1-2.36-.13s-1.58,0-2.37,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.52,189.81a17.09,17.09,0,0,1,3,.31,9.43,9.43,0,0,1,1.47.41c.47.17.94.33,1.42.48,1,.3,1.92.55,2.9.77a14,14,0,0,0,3,.34,6.89,6.89,0,0,1-1.51.1c-.51,0-1-.07-1.52-.14a21.54,21.54,0,0,1-3-.69c-.48-.16-1-.32-1.43-.51a11.61,11.61,0,0,0-1.41-.46q-.72-.19-1.47-.33C354.51,190,354,189.9,353.52,189.81Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M355.1,185.57c.6.43,1.2.86,1.81,1.26s1.23.82,1.86,1.19a10.83,10.83,0,0,0,1.94.94c.35.1.7.2,1.05.28s.71.16,1.08.2a21.87,21.87,0,0,0,4.36.2,14.18,14.18,0,0,1,4.41.21,8,8,0,0,0-2.19-.08c-.73,0-1.46.12-2.2.17a17.94,17.94,0,0,1-4.45-.11,14.85,14.85,0,0,1-2.17-.51,9.63,9.63,0,0,1-2-1A28.79,28.79,0,0,1,355.1,185.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357,184.15a12.76,12.76,0,0,1,2,1,8.21,8.21,0,0,1,.94.64,3.32,3.32,0,0,1,.81.86,19.08,19.08,0,0,0,1.31,1.79,7.28,7.28,0,0,0,.76.81,2.08,2.08,0,0,0,.94.55,1.92,1.92,0,0,1-1.07-.39,6.25,6.25,0,0,1-.87-.75,11.59,11.59,0,0,1-1.4-1.8,5.73,5.73,0,0,0-1.59-1.46C358.31,184.94,357.68,184.54,357,184.15Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M359.81,183.21a24,24,0,0,1,2.84,1.7,13.11,13.11,0,0,1,1.32,1c.42.41.75.8,1.16,1.16a9.15,9.15,0,0,0,1.31.93,8.58,8.58,0,0,0,1.49.64,28.11,28.11,0,0,0,3.21.68,16.09,16.09,0,0,1-3.3-.4,7.47,7.47,0,0,1-1.57-.6,7.76,7.76,0,0,1-1.39-1c-.43-.36-.81-.82-1.18-1.18a16.05,16.05,0,0,0-1.24-1.06c-.43-.34-.87-.67-1.31-1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 355.65,
    cy: 188.21,
    r: 0.48
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.56,191.34a.48.48,0,1,1-.54-.42A.48.48,0,0,1,355.56,191.34Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M355.61,194a.48.48,0,0,1-.42.54.49.49,0,0,1-.54-.42.48.48,0,0,1,1-.12Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M356,197a.48.48,0,1,1-.54-.42A.49.49,0,0,1,356,197Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M357.06,199.34a.48.48,0,1,1-.54-.42A.48.48,0,0,1,357.06,199.34Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.17,200a.49.49,0,0,1-.42.54.47.47,0,0,1-.53-.42.48.48,0,1,1,.95-.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M358,185.76a.48.48,0,1,1-.54-.41A.49.49,0,0,1,358,185.76Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.45,184.48a.48.48,0,1,1-.95.12.49.49,0,0,1,.42-.54A.48.48,0,0,1,360.45,184.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M373.35,189.31c-1.05.73-4.84-.47-9.82-2.93a31.72,31.72,0,0,1-8.07-5.79,7.2,7.2,0,0,1-2.23-3.49c-.24-2.31,1.95-3.83,2.82-4.73s.33-2.08,2-3.6c1.53-1.37,3.29-.76,6.29,2l1.05,1C369.08,175.27,375.15,188.05,373.35,189.31Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.35,189.31c-1.05.73-4.84-.47-9.82-2.93a31.72,31.72,0,0,1-8.07-5.79,7.2,7.2,0,0,1-2.23-3.49c-.24-2.31,1.95-3.83,2.82-4.73s.33-2.08,2-3.6c1.53-1.37,3.29-.76,6.29,2l1.05,1C369.08,175.27,375.15,188.05,373.35,189.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.71,169.22a11.73,11.73,0,0,1,4.94,3.63,37,37,0,0,1,3.23,5.27c.49.9,1,1.78,1.54,2.64q.42.65.87,1.26l.45.64.41.66a22.15,22.15,0,0,1,2.43,5.66,25.23,25.23,0,0,0-1.19-2.83,25.76,25.76,0,0,0-1.5-2.67c-.28-.43-.58-.84-.88-1.25s-.6-.84-.89-1.27c-.57-.86-1.09-1.75-1.59-2.65a40.14,40.14,0,0,0-3.12-5.27,12.2,12.2,0,0,0-2.12-2.19A12.35,12.35,0,0,0,359.71,169.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M358.21,171l1,1.09c.33.36.67.72,1,1.07s.7.69,1.07,1a4.27,4.27,0,0,0,1.17.78c.89.38,1.86.62,2.78,1a7,7,0,0,1,1.31.73,3.22,3.22,0,0,1,1,1.14,3.48,3.48,0,0,0-1.08-1,7.55,7.55,0,0,0-1.32-.61c-.92-.33-1.87-.55-2.82-1a4.4,4.4,0,0,1-1.26-.86,13.31,13.31,0,0,1-1-1.09A21.62,21.62,0,0,1,358.21,171Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M356.72,173.45c.57.79,1.15,1.58,1.75,2.33s1.22,1.52,1.88,2.23a12.5,12.5,0,0,0,2.14,1.91,24.67,24.67,0,0,0,2.51,1.43c.85.46,1.73.9,2.57,1.39a11.07,11.07,0,0,1,1.24.82,4.47,4.47,0,0,1,.55.52c.17.21.3.4.44.6.56.79,1.16,1.55,1.76,2.32l1.79,2.31c-1.32-1.44-2.6-2.91-3.8-4.45-.15-.19-.29-.4-.44-.56a3.35,3.35,0,0,0-.52-.47,9.82,9.82,0,0,0-1.2-.77c-.84-.48-1.71-.91-2.58-1.36a23.85,23.85,0,0,1-2.53-1.48,11.48,11.48,0,0,1-2.16-2A34.37,34.37,0,0,1,356.72,173.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M354.26,176.75c.67.68,1.32,1.36,2,2s1.34,1.33,2,2,1.39,1.27,2.14,1.84a12,12,0,0,0,2.41,1.39c.85.4,1.73.74,2.61,1.09.44.17.89.34,1.32.53a5.49,5.49,0,0,1,1.27.71c.74.58,1.53,1.11,2.31,1.63l2.36,1.58a52.34,52.34,0,0,1-4.85-3,5.66,5.66,0,0,0-1.22-.64c-.43-.18-.87-.35-1.32-.52-.88-.33-1.78-.66-2.64-1a12.3,12.3,0,0,1-2.47-1.47,25.87,25.87,0,0,1-2.13-1.91A56.42,56.42,0,0,1,354.26,176.75Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M355.35,174.61a16.7,16.7,0,0,1,2,1.82,12.74,12.74,0,0,1,1.7,2.16,13,13,0,0,1,.62,1.24c.17.42.36.84.52,1.26a8.64,8.64,0,0,0,1.28,2.37,5.3,5.3,0,0,1-.9-1,11.71,11.71,0,0,1-.66-1.2c-.21-.41-.39-.82-.59-1.23a11.08,11.08,0,0,0-.61-1.19,17.48,17.48,0,0,0-1.59-2.17c-.29-.34-.58-.68-.89-1S355.66,174.94,355.35,174.61Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62,172.63c.94.71,1.86,1.47,2.76,2.23s1.79,1.54,2.64,2.37a6.35,6.35,0,0,1,.6.68l.53.71,1.06,1.42c.34.48.69,1,1.05,1.42a12.41,12.41,0,0,0,1.11,1.38,20.54,20.54,0,0,1-2.41-2.61c-.38-.45-.74-.92-1.1-1.38a13.46,13.46,0,0,0-1.12-1.34c-.83-.82-1.71-1.61-2.56-2.42l-1.29-1.22C358.47,173.46,358,173.05,357.62,172.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,170.74s-3.14-1.79-4.44-.88-1.08,2.74-2.14,4-2.25,1.14-2.87,2.45-.09,3,.53,4.23a7.2,7.2,0,0,1-2.23-3.49c-.24-2.31,1.95-3.83,2.82-4.73s.33-2.08,2-3.6C359.62,167.4,361.38,168,364.38,170.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.19,168.52a.59.59,0,0,0-.59.45.76.76,0,0,0,.27.73.43.43,0,0,0,.6,0,.24.24,0,0,0,.06-.08s.05,0,.06-.06a.76.76,0,0,0,.14-.62A.59.59,0,0,0,359.19,168.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.69,169l-.07-.05c-.26-.18-.56.22-.3.41l.07,0C361.65,169.61,362,169.2,361.69,169Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,177.82a.27.27,0,0,0,.47.26A.27.27,0,0,0,353.84,177.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.46,171.24a.63.63,0,0,0-.17-.78.59.59,0,0,0-.78,0,.72.72,0,0,0-.12.72.38.38,0,0,0,.38.4A.77.77,0,0,0,358.46,171.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.27,172.57a.4.4,0,0,0-.56.56A.4.4,0,0,0,357.27,172.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,169.48a.18.18,0,0,0-.26.26A.18.18,0,0,0,358.21,169.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,173.39a.18.18,0,0,0-.26.25C355.8,173.8,356.06,173.55,355.9,173.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,176.8a.18.18,0,0,0-.25.25C354.27,177.22,354.52,177,354.36,176.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,174.7a.18.18,0,0,0-.25.25C354.34,175.12,354.59,174.86,354.43,174.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,172.1c-.16-.16-.42.09-.25.25A.18.18,0,0,0,358,172.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.61,168.65c-.17-.16-.42.09-.26.25S360.77,168.81,360.61,168.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.83,174.56a.48.48,0,0,0-.93-.1.35.35,0,0,0,0,.25A.49.49,0,0,0,355.83,174.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39,175.55c-.36-.36-.92.19-.56.55S354.75,175.91,354.39,175.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,192.6c.09,1-1.91,2.69-4.32,5.65-1.66,2.06-4.43,4.82-7.33,5.65a5.19,5.19,0,0,1-3.83-.23c-4.07-2-1.59-10-.33-14.52s4.52-8.37,6.38-8.63c1.19-.17,2.76,1.17,4.27,3.1a.21.21,0,0,1,.06.08h0C374.1,186.87,376.53,190.18,376.74,192.6Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,192.6c.09,1-1.91,2.69-4.32,5.65-1.66,2.06-4.43,4.82-7.33,5.65a5.19,5.19,0,0,1-3.83-.23c-4.07-2-1.59-10-.33-14.52s4.52-8.37,6.38-8.63c1.19-.17,2.76,1.17,4.27,3.1a.21.21,0,0,1,.06.08h0C374.1,186.87,376.53,190.18,376.74,192.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,183.62c-.24-.28-2.44-2.08-4.3-.18-4.75,4.84-6,14.66-5.7,16.36.48,2.43,1.39,3.73,3.51,4.1a5.19,5.19,0,0,1-3.83-.23c-4.07-2-1.59-10-.33-14.52s4.52-8.37,6.38-8.63C368.5,180.35,370.07,181.69,371.58,183.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M361,201.88a7.23,7.23,0,0,0,2.17.12,4.22,4.22,0,0,0,2-.64q1.86-1.14,3.63-2.43c.59-.42,1.17-.87,1.72-1.34.28-.23.53-.47.81-.73a10.9,10.9,0,0,1,.89-.67,25.42,25.42,0,0,1,3.84-2.15c-.63.37-1.26.75-1.87,1.15s-1.22.8-1.8,1.24c-.28.22-.56.45-.83.69l-.79.76c-.56.49-1.14.93-1.74,1.37a36,36,0,0,1-3.71,2.38,4.54,4.54,0,0,1-2.15.57A6.72,6.72,0,0,1,361,201.88Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M360.72,199.71a10.42,10.42,0,0,1,2.32-.86,7.52,7.52,0,0,1,1.25-.17c.22,0,.44,0,.63,0h.59c.8,0,1.61-.16,2.42-.27l2.44-.33a24.57,24.57,0,0,1-2.38.64,16.75,16.75,0,0,1-2.46.35,4.42,4.42,0,0,1-.63,0c-.23,0-.41,0-.61,0a6.91,6.91,0,0,0-1.19.1A20.43,20.43,0,0,0,360.72,199.71Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M376.44,193.51c-.65.16-1.3.31-1.95.48s-1.29.32-1.94.5a31.66,31.66,0,0,0-3.78,1.27,16.07,16.07,0,0,1-4,.75,28.41,28.41,0,0,1-4,.05c.66,0,1.33-.08,2-.15s1.33-.12,2-.21,1.31-.18,2-.31a11,11,0,0,0,1.91-.51,24.18,24.18,0,0,1,3.85-1.19A38.09,38.09,0,0,1,376.44,193.51Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M376.77,192.81q-1.38-1.26-2.64-2.64a29,29,0,0,1-2.39-2.9c-.18-.25-.35-.52-.51-.79s-.31-.56-.44-.83a7,7,0,0,0-1.05-1.48,14.85,14.85,0,0,0-3-2.2c.57.27,1.12.55,1.67.85A8,8,0,0,1,370,184a6.65,6.65,0,0,1,1.16,1.52l.44.81c.17.26.33.52.51.77.7,1,1.5,2,2.29,2.92.39.48.79.95,1.2,1.42Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M365.58,183.73l1.69,1.56c.28.26.56.52.84.76a6.1,6.1,0,0,0,.89.67,18,18,0,0,0,2.1.84,5.16,5.16,0,0,1,2,1.16,6.89,6.89,0,0,0-2.1-.86,10.91,10.91,0,0,1-2.19-.8,8.77,8.77,0,0,1-1.76-1.55A17.8,17.8,0,0,1,365.58,183.73Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M363.71,187.76a16.31,16.31,0,0,0,1.43,1,15.31,15.31,0,0,0,1.51.89,7.46,7.46,0,0,0,1.61.6l.42.07.45.07a8.41,8.41,0,0,1,.87.19,31.81,31.81,0,0,1,3.38,1.11c1.11.43,2.2.88,3.26,1.4L373.28,192c-1.12-.36-2.24-.73-3.37-1l-.85-.19-.43-.07-.45-.08a6.7,6.7,0,0,1-1.67-.7A12.77,12.77,0,0,1,363.71,187.76Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M362.76,190.35c.42.21.84.42,1.27.61s.84.39,1.27.56a7.41,7.41,0,0,0,2.62.7c.91,0,1.84-.13,2.77-.21a11.09,11.09,0,0,1,2.82-.07,8.09,8.09,0,0,0-1.39.14l-1.39.23a17.39,17.39,0,0,1-2.81.31,6.73,6.73,0,0,1-2.74-.82A16.84,16.84,0,0,1,362.76,190.35Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M362,193.74c.95-.09,1.9-.13,2.84-.15s1.9,0,2.85,0c.47,0,.95,0,1.42.09.24,0,.48.06.72.11l.69.14c.45.07.92.11,1.39.14s1,0,1.42.06a12.91,12.91,0,0,1-2.85.1,5.67,5.67,0,0,1-.72-.1c-.22,0-.45-.05-.68-.07-.47,0-.94-.06-1.41-.08l-2.83-.11-1.42-.06Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M368.63,184.24a.48.48,0,0,1-.42.54.49.49,0,0,1-.54-.42.48.48,0,0,1,.42-.53A.48.48,0,0,1,368.63,184.24Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M366.76,187.2a.48.48,0,0,1-1,.13.49.49,0,0,1,.42-.54A.47.47,0,0,1,366.76,187.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M365.28,190a.49.49,0,0,1-.42.54.47.47,0,0,1-.54-.41.48.48,0,0,1,1-.13Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M364.66,192.45a.48.48,0,1,1-.54-.42A.48.48,0,0,1,364.66,192.45Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M364.17,195.07a.48.48,0,1,1-.53-.42A.48.48,0,0,1,364.17,195.07Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M363.8,197.62a.49.49,0,0,1-.42.54.47.47,0,0,1-.53-.42.48.48,0,1,1,.95-.12Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M364,200.46a.48.48,0,1,1-1,.12.49.49,0,0,1,.42-.54A.48.48,0,0,1,364,200.46Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M365.69,202.76a.48.48,0,0,1-.42.54.48.48,0,1,1,.42-.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,168.75h0a53.29,53.29,0,0,1-.68,6.71c-1.21,7.15-4.65,18.43-5.86,17.35-2.78-2.48-5.83-7.32-7.54-11.92h0c-1.29-3.45-1.83-6.75-.95-8.82,1.19-2.8,2.57-3.42,5.17-5.38s3.87-6.76,7.09-7.65C383,158.42,383.7,163.3,383.48,168.75Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,168.68c.08-1.47-.81-6.83-2.57-6.61s-4,5.94-5.53,7.38-4.27,1.79-5.44,3.68-.66,6-.54,7.76h0c-1.29-3.45-1.83-6.75-.95-8.82,1.19-2.8,2.57-3.42,5.17-5.38s3.87-6.76,7.09-7.65c2.28-.62,3,4.26,2.77,9.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.65,159.64a.58.58,0,0,0-.7.25.78.78,0,0,0,0,.78.45.45,0,0,0,.56.23l.08-.06.08,0a.81.81,0,0,0,.32-.54A.61.61,0,0,0,380.65,159.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,161.37l0-.12c-.11-.49-.89-.34-.77.16l0,.11A.4.4,0,0,0,382.36,161.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.82,162.45a.29.29,0,0,0-.51.26A.29.29,0,0,0,382.82,162.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,171a.28.28,0,0,0-.51.25A.28.28,0,0,0,370.22,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.41,162a.64.64,0,0,0,.08-.8.57.57,0,0,0-.75-.19.69.69,0,0,0-.34.64.37.37,0,0,0,.23.5A.79.79,0,0,0,379.41,162Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,169.75a.62.62,0,0,0,.09-.8.6.6,0,0,0-.75-.19.71.71,0,0,0-.35.64.38.38,0,0,0,.24.5A.72.72,0,0,0,373.71,169.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,162.81a.39.39,0,0,0-.7.35A.39.39,0,0,0,378.26,162.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.54,161.66a.23.23,0,0,0-.41.21A.23.23,0,0,0,380.54,161.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,160.25c-.11-.2-.43,0-.32.16A.18.18,0,0,0,379.42,160.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,167.78a.17.17,0,1,0-.31.16C375.65,168.14,376,168,375.86,167.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,163.7a.18.18,0,0,0-.32.16C376.78,164.06,377.1,163.9,377,163.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.17,168.77a.18.18,0,0,0-.32.16A.18.18,0,0,0,372.17,168.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56,172.32a.18.18,0,0,0-.32.16A.18.18,0,0,0,369.56,172.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,171.05c-.11-.2-.43,0-.32.16A.18.18,0,0,0,371.23,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,162.78a.18.18,0,0,0-.32.16A.18.18,0,0,0,379,162.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,160.21c-.11-.2-.43-.05-.32.16A.18.18,0,0,0,382,160.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.41,165.24a.49.49,0,0,0-.86-.39.36.36,0,0,0-.11.23A.49.49,0,0,0,377.41,165.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.07,166.73a.49.49,0,0,0,.15-.26.54.54,0,0,0-.13-.47.4.4,0,0,0-.71.18l-.05.2a.46.46,0,0,0-.07.16.49.49,0,0,0,.18.47A.39.39,0,0,0,376.07,166.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,167.86a.4.4,0,0,0-.71.36A.4.4,0,0,0,374.66,167.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59,169.86a.39.39,0,0,0-.7.36A.39.39,0,0,0,371.59,169.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M369.62,170.65a3.64,3.64,0,0,0,0,.74c0,.24,0,.49,0,.74,0,.49.07,1,.13,1.48q.14,1.47.36,2.94a12.93,12.93,0,0,0,.68,2.84,22.34,22.34,0,0,0,1.31,2.64c.95,1.73,2,3.41,2.81,5.25.4.91.75,1.84,1.09,2.77.16.47.33.93.51,1.39a5.86,5.86,0,0,0,.69,1.31,5.3,5.3,0,0,1-.78-1.26c-.22-.45-.41-.91-.6-1.37-.38-.91-.76-1.83-1.18-2.72-.85-1.78-1.9-3.45-2.88-5.18a20.32,20.32,0,0,1-1.3-2.7,11.49,11.49,0,0,1-.65-2.93c-.12-1-.2-2-.26-3,0-.5,0-1,0-1.49A7.32,7.32,0,0,1,369.62,170.65Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M371.2,171.44c.17.51.31,1,.46,1.55l.38,1.56a24.27,24.27,0,0,1,.53,3.2c.06,1.07.16,2.13.25,3.2s.21,2.14.28,3.21q-.33-1.57-.57-3.18c-.16-1-.28-2.13-.35-3.2s-.28-2.11-.45-3.17l-.27-1.58Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M372,169.72c.91,1.78,1.75,3.59,2.48,5.45a14.06,14.06,0,0,1,.47,1.43,8.76,8.76,0,0,1,.23,1.51l.26,3c.07,1,.15,2,.25,3a18.92,18.92,0,0,0,.48,2.92,53.75,53.75,0,0,1,1.08,5.88c-.21-1-.42-1.94-.65-2.91s-.44-1.94-.73-2.89a16.74,16.74,0,0,1-.54-3c-.11-1-.2-2-.29-3l-.22-3a7.56,7.56,0,0,0-.2-1.45c-.12-.47-.27-.94-.43-1.41-.32-.94-.68-1.87-1.06-2.79S372.35,170.64,372,169.72Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M375.54,168.24a44.66,44.66,0,0,1,2,6,11.88,11.88,0,0,1,.29,1.58,7.22,7.22,0,0,1,0,.81c0,.26,0,.52,0,.79,0,1,0,2.1,0,3.15l.08,3.16c0,1.06.08,2.11,0,3.18-.09,2.12-.29,4.22-.54,6.31l.14-3.16c.05-1,.09-2.11.1-3.16,0-2.09-.16-4.21-.22-6.32,0-1.05,0-2.11,0-3.17,0-.27,0-.53,0-.8a6.43,6.43,0,0,0,0-.76c-.05-.51-.15-1-.25-1.54-.22-1-.49-2-.79-3.06S375.86,169.24,375.54,168.24Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M373.85,169.14c.35.68.68,1.36,1,2.05s.62,1.39,1,2c.17.31.4.63.6.94s.41.65.59,1a6.54,6.54,0,0,1,.48,1,2.79,2.79,0,0,1,.19,1.14,3,3,0,0,0-.37-1.06,9.32,9.32,0,0,0-.57-1c-.4-.64-.85-1.22-1.27-1.89a20.24,20.24,0,0,1-.9-2.11C374.29,170.6,374.06,169.88,373.85,169.14Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M378.47,163.31a58.73,58.73,0,0,1,1.25,7.23c.06.62.12,1.23.12,1.85s0,1.22,0,1.83l0,3.67c0,1.23-.06,2.45-.16,3.68,0,.62-.13,1.23-.21,1.83s-.19,1.21-.29,1.82l-.6,3.62-.33,1.8-.16.91-.16.82c0,.07,0,0,0,0v-.11l0-.23.06-.45.12-.91.23-1.82.5-3.64c.15-1.21.36-2.42.44-3.63s.11-2.43.12-3.65l.06-3.67c0-.61,0-1.23,0-1.83s0-1.21-.08-1.82c-.09-1.21-.24-2.43-.4-3.64S378.67,164.51,378.47,163.31Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M380.89,161.48c.27,1.6.47,3.21.64,4.82.09.81.15,1.62.2,2.43s.09,1.63.06,2.45a17.8,17.8,0,0,1-.37,2.43c-.16.8-.33,1.59-.54,2.38-.4,1.57-.84,3.14-1.35,4.68l.53-2.38c.18-.79.35-1.58.52-2.37s.34-1.58.49-2.38a19.41,19.41,0,0,0,.32-2.38c.07-1.59-.07-3.22-.16-4.83Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M382.71,176c-.23.91-.5,1.81-.78,2.7s-.58,1.78-.89,2.66l-.5,1.32c-.19.44-.36.87-.56,1.29l-.56,1.29c-.21.42-.4.85-.61,1.26.13-.45.28-.89.42-1.34l.47-1.32,1-2.63c.32-.88.64-1.76,1-2.63S382.33,176.82,382.71,176Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.52,441.09c3.32-1.11.37-10.71-3.33-13.67-1.18-.94-5.55-3.17-11-5.8-12.05-5.8-29.37-13.54-29.37-13.54l14.76-62.53-60.15.33S252,404.6,252.09,408.26c0,.22,0,.45,0,.67.52,16.58,1.34,30.14,2.7,31C258.45,442.23,354.17,442.22,357.52,441.09Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.52,441.09c-3.35,1.13-99.08,1.15-102.72-1.17-1.36-.85-2.18-14.41-2.7-31,0-.22,0-.45,0-.68a69.35,69.35,0,0,1,1.88-8.78h61.86l-2,8.61s17.32,7.74,29.37,13.53c5.48,2.64,9.84,4.86,11,5.81C357.89,430.38,360.84,440,357.52,441.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.59,441.63c-3.4,1.14-100.87,1-104.57-1.33-1.43-.87-2.24-15.08-2.73-32.27,0-.18,0-.36,0-.54l62.88-.63,0,1.07s37.29,16.73,41.09,19.76S362,440.5,358.59,441.63Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.49,437.85c-16.42-.42-82.73-.58-99,.26-.14,0-.14.09,0,.1,16.27.77,82.58.39,99-.09C357.84,438.11,357.84,437.86,357.49,437.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.16,407.05c-6.46-1.21-14.37-.23-19.32,4.37-.19.18.07.45.28.38a91.19,91.19,0,0,1,19-3.93A.41.41,0,0,0,321.16,407.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.83,409.87c-6.47-1.22-14.38-.23-19.32,4.37-.19.18.06.45.27.38a90.55,90.55,0,0,1,19-3.93A.42.42,0,0,0,325.83,409.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,412.69c-6.46-1.22-14.37-.23-19.32,4.37-.19.18.07.44.28.38a91.25,91.25,0,0,1,19-3.94A.41.41,0,0,0,330.49,412.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.59,393c-2.54-3.5-7.27-1.93-10,.33a34.51,34.51,0,0,0-10,14.8.17.17,0,0,0,.15.23c0,.49.46,1,1,.81,5.34-2,11.29-3.41,15.87-7C329.35,400.09,332,396.27,329.59,393Zm-11.3,11.53c-2.6,1-5.24,1.93-7.8,3.06,1.95-2.88,3.77-5.83,6-8.52a37.46,37.46,0,0,1,3.43-3.69c1.93-1.75,9.55-5.47,8.4,1.62C327.7,400.87,321.4,403.26,318.29,404.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.21,406.38c5.33,2.28,11.45,2.17,17.12,2.73a.8.8,0,0,0,.77-1,.18.18,0,0,0,.09-.27A34.49,34.49,0,0,0,297.8,396c-3.19-1.51-8.16-1.83-9.73,2.2C286.59,402,290.1,405.05,293.21,406.38Zm-2.91-4.61c-2.91-6.57,5.4-4.91,7.71-3.7a36.37,36.37,0,0,1,4.25,2.71,102.36,102.36,0,0,1,8,6.72c-2.77-.45-5.55-.65-8.33-1C298.6,406.1,291.9,405.39,290.3,401.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,303.87s-10.78,39,8,50.58c12.57,7.72,68.11-2.95,70.47-9.81,4.46-13,4.47-17.72,4.47-17.72l-14.26,68.75,70,.82S336.4,339.61,333,279.24c-1.25-22.32-31.25-29.07-52.12-18-20.24,10.77-56.48,40.65-56.48,40.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.21,355.38c3.77-9.23,3.48-12.85,12.89-41.49,1.26-3.82,2.32-7.72,3.44-11.59s2.55-8,3.43-12.09c0-.2.37-.12.31.08-1.09,3.54-1.79,7.19-2.73,10.78s-1.85,7-2.83,10.49c-.42,1.51-.86,3-1.29,4.52.19-.31.38-.62.55-.93.82-1.41,1.65-2.82,2.51-4.21,1.76-2.87,3.9-5.56,5.44-8.56.1-.18.39,0,.28.16-1.78,2.86-3,6-4.71,9-.81,1.42-1.65,2.81-2.52,4.2a28.76,28.76,0,0,1-2.51,3.71c-1.29,4.42-4.05,15.07-5.42,19.47-4.33,13.84-2.91,9.34-6.14,16.77C259.74,356.05,259.05,355.78,259.21,355.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,384.31c-10.53-.11-21.05-.71-31.57-.91-.2,0-.23-.31,0-.31,10.5-.07,21-.47,31.48-.35s21,.64,31.57,1c.26,0,.31.42,0,.42C312.06,384.19,301.58,384.42,291.08,384.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,380.79c1-4.65,2.31-9.22,3.53-13.8s2.47-9.18,3.73-13.76c2.54-9.17,5.18-18.3,7.82-27.43,1.5-5.19,3.11-10.34,4.7-15.5a.12.12,0,0,1,.24.06q-7.05,27.63-15.13,55c-1.52,5.17-2.91,10.41-4.73,15.49A.08.08,0,0,1,265.27,380.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.63,354.45c-18.82-11.55-8-50.58-8-50.58l33.57-1.64,45.7,40.16c-.24.72-.49,1.47-.76,2.25C260.74,351.5,205.2,362.17,192.63,354.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,394.91c-.22,1-.35,1.58-.35,1.58l-70-.82,11-52.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.31,448.31c-.63,3.45,9.2,5.48,13.59,3.67,1.39-.58,5.44-3.34,10.39-6.86,10.88-7.77,26-19.22,26-19.22l51.41,3.1,28.68-52.87s-47.28-2.73-50.53-4.4l-.59-.31c-14.78-7.53-27.06-13.35-28.47-12.57C88,360.94,41.94,444.83,41.31,448.31Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89,373.09l-27,53.51-11.54-.7s-15.14,11.44-26,19.22c-5,3.52-9,6.27-10.38,6.86-4.38,1.82-14.22-.23-13.59-3.68S88,360.94,91.8,358.85c1.4-.78,13.7,5,28.46,12.57l.6.3C121.66,372.14,125.12,372.61,129.89,373.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,449c.64-3.53,47.68-88.9,51.53-91,1.46-.83,14.29,5.3,29.59,13.15l.48.25L92.19,426.8l-.93-.54s-32.62,24.63-37.1,26.5S39.67,452.52,40.32,449Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.16,449.85c8.28-14.19,40.35-72.23,47.46-86.89.06-.12,0-.16-.09,0C83,376.8,51.42,435.09,43.92,449.72,43.77,450,44,450.15,44.16,449.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.65,432.84c4.18-5.08,7.13-12.48,5.48-19-.07-.25-.43-.16-.47.06A91.15,91.15,0,0,1,88,432.43.41.41,0,0,0,88.65,432.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.94,435.57c4.17-5.08,7.12-12.48,5.47-19-.06-.25-.42-.16-.47.06a90.53,90.53,0,0,1-5.71,18.56A.42.42,0,0,0,83.94,435.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.22,438.3c4.18-5.08,7.12-12.48,5.47-19-.06-.25-.42-.16-.46.06a91.15,91.15,0,0,1-5.71,18.56A.41.41,0,0,0,79.22,438.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,447c4.29-.53,5.2-5.43,4.52-8.89a34.55,34.55,0,0,0-8.17-15.87.18.18,0,0,0-.28,0,.79.79,0,0,0-1.19.5C91,428.4,89.37,434.31,90.28,440,90.81,443.37,92.89,447.52,96.94,447Zm-4.66-15.45c.35-2.77.83-5.52,1.08-8.31a103.85,103.85,0,0,1,4.56,9.37,36.82,36.82,0,0,1,1.59,4.79c.61,2.53.19,11-5.47,6.57C90.92,441.55,91.87,434.88,92.28,431.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,408.67c-4.56,3.57-7.42,9-10.63,13.69a.8.8,0,0,0,.53,1.18c0,.11.05.21.19.2a34.53,34.53,0,0,0,16.79-6.05c2.86-2.07,5.53-6.28,2.76-9.59C109.71,405,105.36,406.59,102.7,408.67Zm5.45-.33c7.15.62,1.69,7.1-.48,8.54a37.13,37.13,0,0,1-4.42,2.42,102.33,102.33,0,0,1-9.73,3.76c1.73-2.21,3.24-4.55,4.88-6.83C100.35,413.53,104.2,408,108.15,408.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.85,294.32A282.32,282.32,0,0,1,230.47,323S296.93,357.8,300,390.91c1.08,11.72-.49,33.69-23.48,43.7-25.69,11.19-167.67,3.49-167.67,3.49l17.74-65.37,62.62,0s-44.19,7-49-22.42c-4.46-27.37,12.35-56,12.35-56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.48,434.9c1.56-7.53,3.08-15.1,4.82-22.59s3.62-15,5.59-22.44c.56-2.1,1.14-4.19,1.71-6.29.27-1,.54-2,.83-3a30.55,30.55,0,0,1,.91-3c0-.11.17-.05.16.05a49.58,49.58,0,0,1-1.13,5.78c-.39,1.82-.77,3.64-1.17,5.46-.82,3.73-1.65,7.47-2.51,11.19-1.72,7.47-3.62,14.88-5.56,22.29q-1.65,6.3-3.33,12.61C123.74,435.2,123.43,435.15,123.48,434.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,372.75c5.07-.37,10.16-.53,15.24-.63s10.17-.05,15.26,0,10.17.36,15.24.82a109.64,109.64,0,0,1,15.1,2.18l-3.78-.49-3.79-.36c-2.52-.22-5-.43-7.59-.54-5.06-.29-10.13-.5-15.21-.58s-10.15-.22-15.23-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.44,299.68a183.24,183.24,0,0,0-5.9,17.78,115,115,0,0,0-3.62,18.33,52.35,52.35,0,0,0-.2,9.28,23.09,23.09,0,0,0,2.26,8.82,12.37,12.37,0,0,0,2.71,3.54,22,22,0,0,0,3.72,2.61,41.55,41.55,0,0,0,8.55,3.44,114.92,114.92,0,0,0,18.32,3.32c6.2.72,12.42,1.23,18.66,1.86a136.16,136.16,0,0,1,18.62,2.9,36.54,36.54,0,0,1,8.95,3.3,42.64,42.64,0,0,1,7.78,5.51l1.41,1.26-1.9,0-50.63-.68-25.32-.21c-8.44,0-16.88,0-25.32.18,8.43-.49,16.87-.62,25.31-.77s16.89-.17,25.33-.19l25.32,0,25.33.23-.49,1.23a40.9,40.9,0,0,0-7.51-5.27A34.84,34.84,0,0,0,229.2,373a147,147,0,0,0-18.42-2.84c-6.21-.67-12.44-1.2-18.67-1.95a117.82,117.82,0,0,1-18.53-3.46,40.08,40.08,0,0,1-8.79-3.64,23.63,23.63,0,0,1-3.89-2.82,13.67,13.67,0,0,1-2.91-3.9,24.23,24.23,0,0,1-2.25-9.26,53.26,53.26,0,0,1,.33-9.45,108.29,108.29,0,0,1,4-18.36A166.45,166.45,0,0,1,166.44,299.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,293.63a.12.12,0,0,1,.24,0c.26,2.26,1.06,15.19,1.45,20.07.14,1.73,0,4.83,2.58,4.82,2,0,3-2.18,3.22-3.88.27-2.07-.84-17.08-1.1-22.07,0-.15.23-.15.25,0,.92,5,2.71,20.93,2.18,23.16-.42,1.75-1.32,3.41-3.1,4a32.4,32.4,0,0,1-.09,5.9c0,.16-.52.21-.56.08h0c.09-1.17-.53-5.7-.52-5.73a3.59,3.59,0,0,1-3.22-1.47C221.19,316.14,221.57,299.39,221.62,293.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.44,332c1.81-1.25,3.68-2.38,5.57-3.5s3.8-2.17,5.73-3.21,3.9-2,5.89-2.92,4-1.8,6.08-2.53c-.94.57-1.91,1.08-2.85,1.64l-2.87,1.6c-1.9,1.07-3.84,2.1-5.76,3.12s-3.88,2-5.85,3l-2.95,1.45C216.43,331.07,215.45,331.55,214.44,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.27,321.59c3.53,0,14.52.63,19.76-3.8,4.24-3.58,6.1-15.81,6.83-19.16,0-.17.28-.11.28,0a37.94,37.94,0,0,1-1.42,11.22c-.85,3.1-2,6.56-4.5,8.73s-6.21,3.08-9.58,3.5a43.8,43.8,0,0,1-11.38-.16A.19.19,0,0,1,167.27,321.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.16,148.18c6-1.72,19.07-.66,24.22,14.11,7.31,21-17.22,54.68-22.18,59.17,0,0-29.48-4.32-45-28.63,0,0,24.94-18.39,29.58-32.07A19.4,19.4,0,0,1,221.16,148.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.35,173.35c-.18.16-.35.33-.54.49a51.91,51.91,0,0,1-7.58,5.41,30.93,30.93,0,0,1-8.17,3.54c-.08,0-.12-.1,0-.12a27.61,27.61,0,0,0,8.07-4.16,74.75,74.75,0,0,0,7-5.41,70.93,70.93,0,0,0,12-13.38c.06-.1.24,0,.18.12-.42.72-.86,1.43-1.3,2.14a.1.1,0,0,1,.07.16,79.47,79.47,0,0,1-10.2,13.18,60.29,60.29,0,0,1-13.29,9.83,75.33,75.33,0,0,1-8.39,4s-.07,0,0-.07A78.3,78.3,0,0,0,198.35,173.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.94,157.83c8.71,14.38,4.48,31.62-2.63,45.18a71.45,71.45,0,0,1-7.64,11.87.07.07,0,0,1-.11-.08A84.21,84.21,0,0,0,242.37,193c2.33-7.28,4.08-15.17,3.23-22.94A29.27,29.27,0,0,0,241.75,158C241.67,157.85,241.86,157.7,241.94,157.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.83,215.73c14.25,37.92,27.5,59.86,37.83,60.88C263,277.72,296,252,312.4,238c2.29-2-23.84-29.82-26.6-27.86-10.91,7.73-28.9,26.37-32.87,27.19-2.59.53-9.85-10.09-25.53-27.28C213.4,194.66,207.48,198.84,213.83,215.73Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.64,239.3c4.06-2.45,18.46-13,25.93-23.07,3.62-4.88,12.54-20,9-23s-6.52,1.11-6.52,1.11,2.81-6.94-1-9.71-8.29,3.9-8.29,3.9,2.37-7.34-1.65-9.82-7.37,5-7.37,5,2.48-6.61-1.69-7.26c-5-.79-8.22,11.92-12.49,17.1-1,1.18-21.39,22.49-21.39,22.49Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,183.69c-2.37,9.34-5,13-11.91,19.54-.13.13,0,.36.18.24,7.32-5.78,11.31-9.91,12.19-19.69C321.11,183.31,320.72,183.25,320.61,183.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,188.15c-3.31,9.48-6.15,13.49-12.85,20.86-.1.1.07.28.17.18,7.18-6.68,11.07-10.89,13.13-20.8C330.52,187.94,330.12,187.72,330,188.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.75,195.07c-3.87,9-6.8,13.48-14.22,19.8a.18.18,0,1,0,.21.28c8.2-5.7,11.89-11.33,14.27-19.93C339.17,194.63,339,194.51,338.75,195.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,216.12s-.13-12.07,1-17.38,12.57-23.59,16.66-21.34c5.27,2.9.74,14.75-2.24,20.27,0,0,12.22,6.7,10.8,15.91S285.74,216.12,285.74,216.12Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,178.67c2.91,6.12-1.47,13.11-4,18.68a.55.55,0,0,0,.44.8c4.93,3.15,11,9,11.21,15.21a.14.14,0,0,0,.28,0c.64-6.65-4.82-12.92-10.44-16,2.64-5.67,6.72-12.87,2.53-18.71C304.61,178.61,304.55,178.64,304.57,178.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47,223.43l27.9,33.33s-36.28,24.6-46.7,20-26.5-35.71-35.48-59.41,3.75-20,13.55-9.32,22.75,29.22,25.27,28.9S267.47,223.43,267.47,223.43Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.64,206.88l-15.38-.19c0-.35-.07-.68-.09-1l14.43.17C225,206.19,225.29,206.53,225.64,206.88Zm5.73,6.48-19.65-.24c.1.33.21.67.33,1l20.17.25C231.94,214,231.65,213.69,231.37,213.36Zm6.11,7.49-23-.28c.13.33.27.67.4,1l23.46.29Q237.9,221.36,237.48,220.85Zm34.39,7.83-9.62-.12-18.75-.22-26-.32.44,1,26.39.32,16.88.2,11.51.14Zm6.27,7.49L254,235.88l-3.82,0-29.32-.35c.15.34.31.67.47,1l30.3.37h.68l26.72.32Zm6.27,7.5-60-.73.51,1,60.36.73Zm6.27,7.49-62.41-.76.55,1,62.71.76Zm-58.16,6.71c.21.34.41.68.62,1l57.9.7,1.53-1Zm4.84,7.47q.36.53.72,1l40.82.49,1.75-1Zm6.08,7.49c.36.36.71.7,1.06,1l19.78.24c.76-.31,1.53-.64,2.31-1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.55 225.23 290.97 261.65 299.04 256.06 269.78 218.13 263.55 225.23",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.55 225.23 290.97 261.65 299.04 256.06 269.78 218.13 263.55 225.23",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5,274.41c-6.17,2.47-11.67,3.74-14.82,2.35-10.41-4.58-26.51-35.7-35.49-59.4-4.73-12.49-3.43-17.38.28-17.62C221,210.9,251.5,256.27,263.5,274.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,314.44l93.87,1.37c-.36,1.8,5.68-64.14-9.62-112-1.05-3.27-14.81-9.26-22.3-4.65C167.71,219.3,138.63,313.62,138.58,314.44Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,199.35l-16.12-.19.06,0a9.7,9.7,0,0,1,2-.94l10.91.13A27.51,27.51,0,0,1,216.59,199.35Zm6.89,6.5-30.91-.38c-.34.32-.68.66-1,1l32.22.39Zm2.06,7.44L186,212.81q-.39.48-.78,1l40.62.5C225.71,214,225.63,213.62,225.54,213.29Zm1.73,7.43-46.73-.56c-.24.33-.46.67-.69,1l47.63.58Zm1.44,7.44-52.92-.65-.61,1,53.71.65Zm1.2,7.43-58.41-.71-.56,1,59.12.72Zm1,7.42-63.34-.77-.51,1,64,.77Zm.79,7.43-67.81-.82-.48,1,68.39.84C231.75,251.12,231.72,250.78,231.68,250.44Zm.62,7.42L160.4,257l-.45,1,72.42.88C232.35,258.53,232.33,258.2,232.3,257.86Zm.47,7.43-75.64-.92c-.15.33-.29.66-.43,1l76.12.92C232.8,266,232.79,265.62,232.77,265.29Zm.32,7.41-79.08-1-.41,1,79.52,1Zm.18,7.42-82.24-1-.39,1,82.65,1C233.28,280.8,233.28,280.46,233.27,280.12Zm-85.09,6.38-.37,1,85.52,1v-1Zm-2.73,7.38-.36,1L233.25,296c0-.33,0-.67,0-1Zm-2.61,7.39c-.11.34-.23.68-.34,1l90.54,1.1,0-1Zm-2.47,7.38c-.12.35-.22.69-.32,1l92.66,1.12c0-.32,0-.66,0-1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 295.55,
    width: 49.49,
    height: 30.06,
    transform: "translate(54.28 -23.05) rotate(9.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 291.99,
    width: 8.71,
    height: 1.3,
    transform: "translate(51.11 -21.3) rotate(9.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 290.74,
    width: 5.5,
    height: 1.3,
    transform: "translate(50.91 -21.36) rotate(9.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.51 298.31 168.53 296.11 170.57 292.35 180.83 294.09 181.51 298.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.9,
    y: 294.8,
    width: 6.65,
    height: 2.43,
    transform: "translate(52 -25.15) rotate(9.63)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.15 295.34 139.75 297.7 140.93 298.33 140.76 299.34 138.85 298.3 139.5 294.47 141.65 294.12 141.47 295.13 140.15 295.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.44 304.05 191.04 306.4 189.72 306.61 189.55 307.62 191.7 307.27 192.35 303.44 190.44 302.4 190.27 303.41 191.44 304.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34,298.74a75.5,75.5,0,0,1-1.13,10.74A73.89,73.89,0,0,1,151.73,320a73.92,73.92,0,0,1,1.12-10.74A75.31,75.31,0,0,1,155.34,298.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,324.67a12.27,12.27,0,1,1,14.15-10.05A12.28,12.28,0,0,1,170.36,324.67Zm4-23.52a11.58,11.58,0,1,0,9.48,13.36A11.6,11.6,0,0,0,174.35,301.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,314.15A9.44,9.44,0,1,1,174,303.26,9.45,9.45,0,0,1,181.72,314.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,302.07a1,1,0,1,1-.81-1.15A1,1,0,0,1,188.45,302.07Z",
    style: {
      fill: "#ffc427"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,294.47a528.82,528.82,0,0,1,28.37-53.87,289,289,0,0,1,17-25.33,131.54,131.54,0,0,1,10-11.71l1.36-1.38.68-.68.74-.68a22.55,22.55,0,0,1,3.25-2.46,20.61,20.61,0,0,1,3.73-1.78,16.93,16.93,0,0,1,4.11-.82,15.45,15.45,0,0,1,8.15,1.76,16.86,16.86,0,0,1,6.14,5.57,14.29,14.29,0,0,1,2.46,8l-.07,1.08-.13,1-.25,1.93c-.21,1.27-.41,2.54-.67,3.8-1,5-2.33,10-3.8,14.86s-3.09,9.71-4.83,14.49a526.48,526.48,0,0,1-24.3,55.83c4-9.34,7.9-18.68,11.55-28.13s7.24-18.92,10.47-28.5,6.19-19.25,8-29.1c.23-1.23.4-2.46.61-3.69l.23-1.84.12-.93.05-.81a11.22,11.22,0,0,0-2-6.29,13.58,13.58,0,0,0-5-4.52,12.59,12.59,0,0,0-6.53-1.4,14.12,14.12,0,0,0-3.33.65,17.37,17.37,0,0,0-3.12,1.47,28.35,28.35,0,0,0-5.46,4.7,142.66,142.66,0,0,0-9.81,11.39C181,225,175.36,233.36,169.9,241.87s-10.65,17.21-15.69,26S144.27,285.52,139.5,294.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.13,216.77c-4.56-.12-12.16-7.56-13.6-14.51-.09-.48,1.85-4.59,4-9.69,1.28-3.1,2.63-6.59,3.63-9.86.21-.67,19,11.27,19,11.27a54.78,54.78,0,0,0-5.84,12,9.07,9.07,0,0,0-.27,1.38,1.24,1.24,0,0,1,0,.23C223.61,210.22,222,216.9,217.13,216.77Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,207.31c0,.07,0,.15-.05.23a15.37,15.37,0,0,1-2.13-.53c-12-4-10.53-20-10-24.07,3.48,1.64,18.25,11,18.25,11a54.78,54.78,0,0,0-5.84,12A8.12,8.12,0,0,0,224,207.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,156.1c-4.24,6.72-6.14,29-2.21,35.12,5.7,8.91,17.9,12.94,26.2,5.43,8.05-7.27,10-36.31,5.35-42.2C237.63,145.79,221.41,146.16,215.15,156.1Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,175.78c0-.05.11.09.1.15-.24,1.48-.27,3.22,1,3.9,0,0,0,.09,0,.08C240.44,179.46,240.5,177.15,241,175.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,174.4c2.43.13,2,5-.26,4.84S240.47,174.29,242.5,174.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,172.08a16.13,16.13,0,0,0,1.93.51,3.21,3.21,0,0,0,2.07.15,1,1,0,0,0,.56-1.12,2.53,2.53,0,0,0-2-1.66,3.73,3.73,0,0,0-2.69.12A1.1,1.1,0,0,0,229.56,172.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.72,171.46a18.29,18.29,0,0,1-1.85-.74,3.3,3.3,0,0,1-1.74-1.12,1,1,0,0,1,.22-1.24,2.58,2.58,0,0,1,2.58-.15,3.8,3.8,0,0,1,2.08,1.72A1.09,1.09,0,0,1,244.72,171.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.19,188.08c.31.4.61.92,1.14,1A4,4,0,0,0,232,189a.06.06,0,0,1,.06.09,2,2,0,0,1-2,.56,1.59,1.59,0,0,1-1-1.47C229,188,229.14,188,229.19,188.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34,183.82a5.11,5.11,0,0,0,3.09,2.7,6.56,6.56,0,0,0,1.82.32h.69a.39.39,0,0,0,.34-.3h0a.76.76,0,0,0,0-.15h0v-.14c.18-1.14.3-2.9.3-2.9.39.26,2.4,1.5,2.45.9.35-5,.73-10.57,0-15.63a.14.14,0,0,0-.27,0c-.53,4.79-.21,9.65-.66,14.48a9.08,9.08,0,0,0-2.3-1c-.17,0-.16,3.41-.28,3.91l0,.06c-2,0-3.34-.78-5-2.32C231.39,183.6,231.26,183.69,231.34,183.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,174.18a4.76,4.76,0,0,1,1.25,0,5.1,5.1,0,0,1,1.23.37,3.61,3.61,0,0,1,1.08.8,3.12,3.12,0,0,1,.66,1.23l.22.81-.81-.28a8.37,8.37,0,0,0-1.76-.41,3.66,3.66,0,0,0-1.84.19,2.71,2.71,0,0,1,1.84-.86,5.23,5.23,0,0,1,2.07.24l-.58.54a3.12,3.12,0,0,0-1.26-1.61A9.31,9.31,0,0,0,228.74,174.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,178a7.16,7.16,0,0,0,1.95-.26c.14,0,.74-.3.73-.41a3.63,3.63,0,0,0-.11-1,2.44,2.44,0,0,1,.3,1,1.27,1.27,0,0,1-.84.68A4,4,0,0,1,230.33,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.08,176.12c1.49-.66,5.14-7,5.14-7s14.54-.88,19.87-12c0,0,3.95,8.9,8.86,12.17,0,0,3.75-12.1-6.79-17.35,0,0-9.49-7.73-22.07-.43s-8.41,23.85-8.41,23.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,154.74a11.57,11.57,0,0,1-2.28,5.73A21.41,21.41,0,0,1,232,165a19.37,19.37,0,0,1-5.37,3.28,24.24,24.24,0,0,1-7.07,1.17c-.08,0-.07.13,0,.13a27.64,27.64,0,0,0,7.41-.89,19.35,19.35,0,0,0,5.76-3.1,15.68,15.68,0,0,0,4.47-4.81,13.42,13.42,0,0,0,1.51-6A.13.13,0,0,0,238.48,154.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,151.11c-1.56-2.27-5.52-7.13-10-9.18s-11.35-2.42-13.71-2.61c-1.94-.16-7.9-2-13.28-1.45-3.55.37-6.61,4-7.09,6.25-.73,3.37,6.45,4.27,6.23,5.6-.14.88-2.94,4.4-1.77,7.1s1.2,2.36,1.88,3.86c1.65,3.64,11.27-9.65,18.46-11.27S243.52,151.11,243.52,151.11Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,151.14s-11.49-3.35-18.68-1.72-15.71,14.7-17.37,11.06c-.72-1.6-.56-3.21.22-5.6,3-3.51,8.3-8.54,14.12-10.7,5.44-2,11.87-.75,17.83,2.09A36.54,36.54,0,0,1,243,151.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.64,167.35c5-3.18,11.08-9.12,18.21-12.19s20.18.64,21.68,1.69c3.62,2.56,3.33,4.87,4.13,4.9s-.3-6.57-1-7.86a14.47,14.47,0,0,0-4.39-4.54c-1.66-1-12.35-6.24-18.69-4.22s-19,10.83-20,14.51c-.23.88.45,2,.12,3.21-.45,1.63-1.15,3.41-1.33,4.63C202.29,168.46,203.33,167.55,203.64,167.35Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,153.26a20.57,20.57,0,0,1-1.32-3.31,15.15,15.15,0,0,1-.71-3.53c0-.09-.13-.1-.13,0a11.46,11.46,0,0,0,.34,3.69,9.94,9.94,0,0,0,1.63,3.29C224.12,153.5,224.29,153.38,224.23,153.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,165.28c.06-.32,0-.65.06-1a5.73,5.73,0,0,1,.21-1.08,9.26,9.26,0,0,0,.67-2,7.35,7.35,0,0,0-.1-1.69,2.79,2.79,0,0,1,.2-1.87c.05-.07-.07-.15-.12-.07-.67,1.07-.42,2.28-.51,3.46a13.24,13.24,0,0,1-.66,2.14,3.26,3.26,0,0,0,0,2C204.77,165.38,204.94,165.39,205,165.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,162.22c-.09-.61-.22-1.2-.25-1.82a13.4,13.4,0,0,1,.07-1.79c0-.59.15-1.17.22-1.75s.08-1.4.19-2.09c0-.09-.12-.09-.13,0-.12.71-.36,1.4-.5,2.11a14.54,14.54,0,0,0-.23,1.86,8.93,8.93,0,0,0,.05,1.79,4.46,4.46,0,0,0,.51,1.71A0,0,0,0,0,208.55,162.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,159.56a12,12,0,0,1-.57-3.36c0-1.12,0-2.24.09-3.35,0-.07-.12-.1-.14,0a14.16,14.16,0,0,0-.45,3.43,7.29,7.29,0,0,0,.21,1.68,7.73,7.73,0,0,0,.72,1.67C211.88,159.68,212,159.65,212,159.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,157.13a4.05,4.05,0,0,1-.34-1.53c-.06-.58-.11-1.17-.14-1.76s-.06-1.13-.09-1.69a4.24,4.24,0,0,1,.17-1.7c0-.07-.08-.12-.12,0a4.17,4.17,0,0,0-.45,1.63,10.72,10.72,0,0,0-.06,1.88,14.42,14.42,0,0,0,.22,1.84,2.74,2.74,0,0,0,.66,1.49C215.35,157.31,215.49,157.23,215.43,157.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.05,153.56c-.13-.52-.25-1-.34-1.58s-.14-1.07-.19-1.6-.13-1.13-.14-1.69a.07.07,0,0,0-.14,0,10.49,10.49,0,0,0-.15,1.68,13.28,13.28,0,0,0,.14,1.67,14.55,14.55,0,0,0,.34,1.62,4.38,4.38,0,0,0,.65,1.52.1.1,0,0,0,.17-.06A8.53,8.53,0,0,0,219.05,153.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,152.94c-.08-.65-.15-1.29-.29-1.93a18.28,18.28,0,0,0-.55-1.92,16.89,16.89,0,0,0-1.59-3.55c0-.06-.15,0-.13,0,.78,2.47,1.67,4.91,2.42,7.39A.07.07,0,0,0,228.19,152.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,151.25a8.21,8.21,0,0,0-.49-1.89,18.74,18.74,0,0,0-2-3.56c-.05-.07-.17,0-.13.06.54,1.18,1.1,2.35,1.57,3.55a17.67,17.67,0,0,1,.61,1.82c.17.63.2,1.26.33,1.89a.05.05,0,0,0,.1,0A4.71,4.71,0,0,0,232.2,151.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,151.69a9.65,9.65,0,0,0-.4-1.83,10.66,10.66,0,0,0-1.64-3.11c-.05-.07-.15,0-.12.07a20.72,20.72,0,0,1,1.34,3.28c.18.57.32,1.14.48,1.71a17.08,17.08,0,0,0,.4,1.75,0,0,0,0,0,.08,0A9.55,9.55,0,0,0,236,151.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,151.25c-.19-.53-.4-1.05-.61-1.57a5.32,5.32,0,0,0-.8-1.46c0-.06-.14,0-.11.08.36,1,.71,2.06,1,3.09a14.2,14.2,0,0,1,.44,3,0,0,0,0,0,.09,0A5.35,5.35,0,0,0,239.23,151.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.23,152.33a8.62,8.62,0,0,0-1.44-2.93c0-.07-.16,0-.12.07a10.5,10.5,0,0,1,1.14,2.95,14.45,14.45,0,0,1,.39,3.15.05.05,0,0,0,.1,0A7.14,7.14,0,0,0,242.23,152.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.72,156.07a5.78,5.78,0,0,0,0-.72,7,7,0,0,0-.19-1.45,15.07,15.07,0,0,0-1-2.79c0-.08-.17,0-.13.06a11.48,11.48,0,0,1,.89,2.75,8.48,8.48,0,0,1,.17,1.41c0,.23,0,.46,0,.7a3.08,3.08,0,0,0,0,.68.07.07,0,0,0,.12,0A1.83,1.83,0,0,0,244.72,156.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,157.58a10.23,10.23,0,0,0-.44-2.36c-.13-.39-.27-.77-.38-1.17a.07.07,0,1,0-.13,0,7.77,7.77,0,0,1,.28,1.2l.21,1.15c.06.39.13.77.19,1.15a11.6,11.6,0,0,0,.19,1.18.06.06,0,0,0,.11,0A5.28,5.28,0,0,0,246.72,157.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,175.07s-3.09-8.1-6.65-7.17-2.44,11.83.89,14.12a3.84,3.84,0,0,0,5.5-.75Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.49,171a0,0,0,0,0,0,.09c2.31,1.69,3.06,4.42,3.39,7.13a2.13,2.13,0,0,0-2.94-1.34c-.08,0,0,.15,0,.16a2.37,2.37,0,0,1,2.33,1.43,12,12,0,0,1,.7,2.35c.06.26.51.24.48-.05v-.06C214.33,177.47,212.93,172.23,209.49,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.43 178.55 263.02 181.79 263.33 204.89 296.46 206.22 296.43 178.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.36 214.96 266.96 214.6 264.14 170.96 240.83 171.28 240.36 214.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.97 171.1 252.43 166.88 246.13 166.97 243.9 171.24 253.97 171.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.11 174.38 278.99 178.47 279.38 207.6 321.16 209.28 321.11 174.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.74,176.54s-4.75,7.41-5,15.64,5.07,14.88,5.07,14.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,216.4c5.12,6.31,40.45,53.21,42.89,54.89,0,0-8.19,30.85-25,21.22-15.85-9.08-27.17-49.44-31.58-71C189.37,210,195.68,204.42,205.41,216.4Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,216.4c5.12,6.31,40.45,53.21,42.89,54.89,0,0-8.19,30.85-25,21.22-15.85-9.08-27.17-49.44-31.58-71C189.37,210,195.68,204.42,205.41,216.4Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,271.29s-.16.59-.47,1.59l-.33,1a65.52,65.52,0,0,1-2.54,6.37l-.49,1a39.42,39.42,0,0,1-3.83,6.37q-.37.51-.78,1c-4,4.89-9.54,7.9-16.54,3.89a23.2,23.2,0,0,1-5.14-4.15c-.31-.32-.63-.66-.93-1a48.43,48.43,0,0,1-4.77-6.47l-.63-1c-1.21-2-2.38-4.17-3.51-6.45-.17-.33-.33-.67-.5-1-1-2.07-2-4.23-2.88-6.45-.15-.33-.29-.67-.43-1-.86-2.1-1.69-4.26-2.48-6.44-.13-.33-.25-.67-.37-1-.76-2.13-1.49-4.29-2.19-6.44l-.33-1q-1-3.24-1.95-6.44c-.1-.34-.2-.67-.29-1-.63-2.18-1.21-4.33-1.76-6.42l-.27-1c-.56-2.22-1.09-4.37-1.57-6.42-.08-.35-.16-.69-.23-1q-.76-3.3-1.35-6.2a2.07,2.07,0,0,1,0-.22c-.07-.35-.13-.68-.18-1a16.8,16.8,0,0,1,0-6.41,7.3,7.3,0,0,1,.3-1c1.44-3.91,5.24-4.62,10.39.13q.51.47,1.05,1,1,1,2.1,2.37c.64.79,1.75,2.21,3.21,4.1.25.33.51.67.79,1l5,6.46.78,1,5,6.47q.38.51.78,1l5,6.46.78,1c1.68,2.18,3.35,4.36,5,6.47.25.34.51.68.78,1,1.74,2.26,3.43,4.44,5,6.48l.78,1c1.9,2.43,3.62,4.62,5.1,6.47l.82,1A46.71,46.71,0,0,0,248.3,271.29Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,214l-11.74-.15a7.3,7.3,0,0,1,.3-1l10.39.13Q202.77,213.48,203.31,214Zm5.31,6.47-17.1-.21c0,.33.11.66.18,1l17.71.22C209.13,221.17,208.87,220.83,208.62,220.5Zm5.75,7.48-21.28-.26c.07.33.15.67.23,1l21.83.26Zm5.74,7.49-25.22-.31.27,1,25.73.31Q220.49,236,220.11,235.47Zm5.73,7.48-28.92-.35c.09.34.19.67.29,1l29.41.36Zm5.77,7.49-32.45-.39.33,1,32.9.4C232.12,251.12,231.86,250.78,231.61,250.44Zm5.8,7.49-35.73-.44c.12.34.24.68.37,1l36.14.44Zm5.88,7.48-38.76-.47c.14.34.28.68.43,1l39.15.48Zm-35.45,7c.17.34.33.68.5,1l39.16.48.33-1Zm4,7.46.63,1,32,.39.49-1Zm5.4,7.48c.3.36.62.7.93,1l21.68.26q.4-.48.78-1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,231c3.92-3.26,33.76,13.47,30,19.94-18.05,30.6-31.41,40.15-37.83,42.88s-16.29-6.64-17.75-12.45C213,273,236.88,234.23,240.77,231Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,198.88c2.15,3.67-7.36,8.2-7.36,8.2a7.87,7.87,0,0,1,4.91,2.1c2.25,2.32-.39,6.87-.39,6.87a9.65,9.65,0,0,1,4.82,3c1.93,2.43-.08,7.4-.08,7.4a7.44,7.44,0,0,1,2.55,5.35c-.1,4.57-6,9.74-10.87,12.45-4.62,2.59-19.46,8.53-22.25,9.71l-19.47-31.8s15-14.95,20.59-17.83C269,201.94,288.55,193.27,291.83,198.88Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,207c-5.62,1.38-10.9,4.11-16,6.8a.1.1,0,1,0,.09.17c5-2.73,10.87-4.19,16-6.71A.14.14,0,0,0,284.33,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.88,215.83a15.33,15.33,0,0,0-3.52,1.78c-1.2.72-2.39,1.46-3.57,2.21q-3.54,2.27-7,4.71c-.1.07,0,.25.09.18,2.36-1.51,4.73-3,7.15-4.38,1.21-.7,2.42-1.39,3.64-2.07a18.62,18.62,0,0,0,3.35-2.09A.2.2,0,0,0,288.88,215.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,226.55a10.35,10.35,0,0,0-3.08,1.78c-1.06.71-2.13,1.41-3.2,2.11-2.13,1.4-4.27,2.8-6.45,4.12-.11.07,0,.24.09.18,2.23-1.34,4.47-2.64,6.68-4l3.25-2a9.92,9.92,0,0,0,2.79-2.08A.08.08,0,0,0,293.62,226.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,211.13c-2.28.38-5.2-5-6.29-8.67s-5.62-8.4-8.62-7.77-1.86,7.81-.86,12.25,1,21.69,0,24.06,10.16,2.85,10.16,2.85Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,270.14q3.19-4.77,6.33-9.59l3.11-4.82c1-1.62,2.06-3.24,2.91-4.91l0-.1.1,0q4.58-1.81,9.06-3.83c1.49-.68,3-1.38,4.41-2.15a22.69,22.69,0,0,0,4.05-2.67,28.18,28.18,0,0,0,6.69-7,6.79,6.79,0,0,0,1-4.47,5,5,0,0,0-2.39-3.72l-.32-.18.17-.32a7.31,7.31,0,0,0,.57-6.37,6.65,6.65,0,0,0-2-2.58,5.12,5.12,0,0,0-3-1h-.53l.26-.44a12.16,12.16,0,0,0,1.23-2.9,4.15,4.15,0,0,0-.09-3,5.08,5.08,0,0,0-2.38-1.9,14.6,14.6,0,0,0-3-1l-.51-.11.47-.22a23.4,23.4,0,0,0,5-3,9.45,9.45,0,0,0,2-2.15,3.47,3.47,0,0,0,.54-2.81,3.51,3.51,0,0,1-.46,2.85,9.75,9.75,0,0,1-2,2.24,23.44,23.44,0,0,1-5,3.2l0-.32a13.69,13.69,0,0,1,3.14.94,5.53,5.53,0,0,1,2.62,2.05,4.58,4.58,0,0,1,.19,3.33,12.75,12.75,0,0,1-1.24,3.07l-.27-.44a5.71,5.71,0,0,1,3.45,1.11,7,7,0,0,1,2.25,2.82,6.84,6.84,0,0,1,.53,3.57,9,9,0,0,1-1.11,3.44l-.14-.5a5.72,5.72,0,0,1,2.81,4.24,7.06,7.06,0,0,1-.12,2.59,9.48,9.48,0,0,1-1,2.37,18.64,18.64,0,0,1-3.15,3.9,44.43,44.43,0,0,1-3.75,3.26c-.64.51-1.3,1-2,1.48s-1.43.85-2.16,1.24c-1.47.77-3,1.47-4.46,2.15-3,1.35-6.06,2.57-9.14,3.73l.15-.14c-.92,1.73-2,3.31-3,4.92s-2.12,3.19-3.22,4.77Q261.46,265.46,258.12,270.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34,244.81l31.27,24.79s-21.28,23.71-30.54,24.7c-7.77.82-16.85-8.61-16.43-14.55C215.3,270.55,230.34,244.81,230.34,244.81Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.82,251.53l-12.17-.15.55-1,10.33.12ZM247,258l-23.74-.29-.51,1,25.54.31Zm9.5,7.53-36.85-.44c-.15.33-.31.67-.45,1l38.59.47Zm-40,6.93c-.13.34-.25.68-.36,1l41.28.5,1-1Zm-1.92,7.39a4.91,4.91,0,0,0,0,1l35.39.43,1.06-1Zm3.11,7.46c.27.34.55.68.86,1l23,.28q.63-.48,1.26-1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,268.26c2.64-10.15,9.94-19.35,10.41-19.87.22-.26.62-.14.57,0-.89,1.81-7.84,13-10.64,20C218.62,268.42,218.29,268.33,218.31,268.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.53 248 259.11 274.38 265.78 267.18 233.08 239.72 228.53 248",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.53 248 259.11 274.38 265.78 267.18 233.08 239.72 228.53 248",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14,233.51c1,3.17,2.08,6.34,3.18,9.49s2.16,6.31,3.31,9.44C202.92,258.7,205.26,265,208,271c1.36,3,2.77,6.05,4.41,8.93a49.22,49.22,0,0,0,2.63,4.2,27.7,27.7,0,0,0,3.24,3.7,24.27,24.27,0,0,0,8.05,5.59,10.45,10.45,0,0,0,4.82.71,13.18,13.18,0,0,0,4.67-1.61,12.13,12.13,0,0,1-4.63,1.89,10.62,10.62,0,0,1-5-.49,25,25,0,0,1-8.45-5.49,25.41,25.41,0,0,1-3.4-3.77,48.84,48.84,0,0,1-2.73-4.26,95.34,95.34,0,0,1-4.51-9q-4-9.21-7.18-18.73C197.77,246.36,195.82,240,194.14,233.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.89,237.07c.49.73.92,1.46,1.37,2.18l.66,1.09c.22.38.45.74.65,1.13a6.79,6.79,0,0,1-1.75-1.95,7.65,7.65,0,0,1-.59-1.18A5.07,5.07,0,0,1,193.89,237.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,228.05a134.9,134.9,0,0,1,14.21,18.64,115,115,0,0,1-7.52-9C219.38,234.57,217.09,231.4,215,228.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.49,228.62a9.42,9.42,0,0,1,1.91,2.83,7.15,7.15,0,0,1,.7,3.34c-.17-.54-.33-1.08-.53-1.6s-.4-1-.64-1.53C218.48,230.64,218,229.65,217.49,228.62Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusCuate);
export default __webpack_public_path__ + "static/media/Focus-cuate.5745e0ae1c78eaa5f148b2eceff28ac5.svg";
export { ForwardRef as ReactComponent };